import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react'
import { RectangleIcon } from '@/assets'

interface FooterLinkProps {
  href: string
  children: React.ReactNode
}

const FooterLink = ({ href, children }: FooterLinkProps) => (
  <a
    href={href}
    className="text-gray-950 hover:text-gray-900 font-satoshi transition-colors duration-200"
  >
    {children}
  </a>
)


interface FooterProps {
  className?: string
}

const Footer = ({ className }: FooterProps) => {
  const currentYear = new Date().getFullYear()
    const microSite = new URLSearchParams(window.location.search).get('template');

  const aboutUsLinks = [
    { title: "Who we are", href: "/about/who-we-are" },
    { title: "Our History", href: "/about/history" },
    { title: "Leadership", href: "/about/leadership" },
    { title: "Legal Foundation", href: "/about/legal-foundation" },
    { title: "Members Countries", href: "/about/member-countries" }
  ]

  const opportunitiesLinks = [
    { title: "Procurement", href: "/opportunities/procurement" },
    { title: "Careers", href: "/opportunities/careers" }
  ]

  const strategicPillarsLinks = [
    { title: "Earth Observation", href: "/programmes/earth-observation" },
    { title: "Satellite Connectivity", href: "/programmes/satellite-connectivity" },
    { title: "Astronomy", href: "/programmes/astronomy" },
    { title: "Navigation & Positioning", href: "/programmes/navigation-positioning" }
  ]

  const programmesLinks = [
    { title: "GMES & Africa", href: "/programmes/gmes-africa" },
    { title: "EO Africa Initiative", href: "/programmes/eo-africa-initiative" }
  ]

  const socialLinks = [
    {
      href: "https://facebook.com/africanspaceagency",
      icon: <Facebook className="h-5 w-5" />,
      label: "Follow us on Facebook"
    },
    {
      href: "https://twitter.com/africanspaceagency", 
      icon: <Twitter className="h-5 w-5" />,
      label: "Follow us on Twitter"
    },
    {
      href: "https://linkedin.com/company/africanspaceagency",
      icon: <Linkedin className="h-5 w-5" />,
      label: "Connect with us on LinkedIn"
    },
    {
      href: "https://instagram.com/africanspaceagency",
      icon: <Instagram className="h-5 w-5" />,
      label: "Follow us on Instagram"
    }
  ]

    if(microSite){
    return null; // Hide header for microsite view
  };

  return (
    <footer className={`${className} md:pt-8`}>
 
      <div  className='border-b border-x-gray-50 w-full '> </div>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8  mb-5">
          {/* About Us Section */}
          <div>
            <h3 className="text-sm font-medium font-satoshi uppercase text-gray-500 mb-6">
              ABOUT US
            </h3>
            <nav className="space-y-3">
              {aboutUsLinks.map((link, index) => (
                <div key={index}>
                  <FooterLink href={link.href}>
                    {link.title}
                  </FooterLink>
                </div>
              ))}
            </nav>
          </div>

          {/* Opportunities Section */}
          <div>
            <h3 className="text-sm font-medium font-satoshi uppercase text-gray-500 mb-6">
              OPPORTUNITIES
            </h3>
            <nav className="space-y-3">
              {opportunitiesLinks.map((link, index) => (
                <div key={index}>
                  <FooterLink href={link.href}>
                    {link.title}
                  </FooterLink>
                </div>
              ))}
            </nav>
          </div>

          {/* Strategic Pillars Section */}
          <div>
            <h3 className="text-sm font-medium font-satoshi uppercase text-gray-500 mb-6">
              STRATEGIC PILLARS
            </h3>
            <nav className="space-y-3">
              {strategicPillarsLinks.map((link, index) => (
                <div key={index}>
                  <FooterLink href={link.href}>
                    {link.title}
                  </FooterLink>
                </div>
              ))}
            </nav>
          </div>

          {/* Programmes Section */}
          <div>
            <h3 className="text-sm font-medium font-satoshi uppercase text-gray-500 mb-6">
              PROGRAMMES
            </h3>
            <nav className="space-y-3">
              {programmesLinks.map((link, index) => (
                <div key={index}>
                  <FooterLink href={link.href}>
                    {link.title}
                  </FooterLink>
                </div>
              ))}
            </nav>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 my-8"></div>

        {/* Logo and Contact Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Logo and Description */}
          <div className="flex items-start space-x-4">
            <img
              src='https://res.cloudinary.com/dondpcuxz/image/upload/v1755252898/logo-afsa_j8mygd.png'
              alt="AFSA Logo"
              className="h-16 w-auto flex-shrink-0"
            />
            <p className="text-base font-satoshi text-gray-950 leading-relaxed">
              The African Space Agency is the primary point of contact for Africa's cooperation with Europe and other international partners.
            </p>
          </div>

          {/* Contact Information */}
          <div className="text-base font-satoshi text-gray-950 lg:text-right">
            <p>Egypt Space City, New Cairo</p>
            <p>Governorate, Egypt</p>
            <p className="mt-4">
              <a 
                href="mailto:info@africanspaceagency.org"
                className="hover:text-gray-700 transition-colors duration-200"
              >
                info@africanspaceagency.org
              </a>
            </p>
          </div>
        </div>
      </div>
                   <div className="bg-forestGreen-100 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap py-3">
          <span className="text-sm font-medium font-pt-serif italic text-white mx-8 inline-flex items-center tracking-wide">
            Unifying Africa's Space Ambitions 
            <img src={RectangleIcon} alt="separator" className='h-5 w-5 mx-4 rotate-[-34]' />
            Unifying Africa's Space Ambitions 
             <img src={RectangleIcon} alt="separator" className='h-5 w-5 mx-4 rotate-[-34] ' />
            Unifying Africa's Space Ambitions 
            <img src={RectangleIcon} alt="separator" className='h-5 w-5 mx-4 rotate-[-34]' />
            Unifying Africa's Space Ambitions 
           <img src={RectangleIcon} alt="separator" className='h-5 w-5 mx-4 rotate-[-34]' />
            Unifying Africa's Space Ambitions 
           <img src={RectangleIcon} alt="separator" className='h-5 w-5 mx-4 rotate-[-34]' />
          </span>
        </div>
      </div>


        <div className="bg-wine-100 w-full px-4 sm:px-6 lg:px-8 py-6">
          <div className="max-w-[1440px] flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 mx-auto" >
        
            <p className="text-white text-sm font-satoshi">
              {currentYear} All Right Reserved
            </p>

        
            <div className="flex space-x-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="text-white hover:text-gray-200 transition-colors duration-200"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

      {/* Custom Animation CSS */}
      <style>{`
        @keyframes marquee {
          0% {
            transform: translate3d(100%, 0, 0);
          }
          100% {
            transform: translate3d(-100%, 0, 0);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>
    </footer>
  )
}

export default Footer